import type { SVGProps } from 'react';
const SvgEarth = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Earth 1 Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M9.25 17.84a8.59 8.59 0 1 0 0-17.18 8.59 8.59 0 0 0 0 17.18" />
      <path d="M1.321 12.554h2.313a2.313 2.313 0 0 0 2.312-2.313V8.26A2.31 2.31 0 0 1 8.26 5.946a2.313 2.313 0 0 0 2.312-2.312V.754M17.84 9.118a4.7 4.7 0 0 0-2.141-.529h-2.815a2.312 2.312 0 1 0 0 4.625 1.65 1.65 0 0 1 1.652 1.652v1.15" />
    </g>
  </svg>
);
export default SvgEarth;
